import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-share",
  "use": "icon-share-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 14 14\" id=\"icon-share\">\n<style type=\"text/css\">\n\t#icon-share .st0{fill:#707070;}\n</style>\n<path class=\"st0\" d=\"M2.8,8.7c0,0,3.5-3.2,6.8-2.3v2.4L14,4.5L9.6,1.1v2.6C9.6,3.8,4,3.2,2.8,8.7z M10,11.5H1.2v-7h2.3\n\tC4.5,3.4,6,3.2,6,3.2H0v9.6h11.4V8.5L10,9.9V11.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol